module.exports = __webpack_public_path__ + "img/delete-red.a0d5ae3b.svg";